<script>
  import { setLanguage, getLanguage } from "../i18n/language.js";

  $: ENactive = $getLanguage === "en";
  $: ITactive = $getLanguage === "it";

  const setLang = (lang) => {
    setLanguage(lang);
  };
</script>

<div class="languages">
  <p class={ENactive ? "active" : ""} on:click={() => setLang("en")}>EN</p>
  <p class={ITactive ? "active" : ""} on:click={() => setLang("it")}>IT</p>
</div>

<style>
  .languages {
    display: flex;
  }

  .languages p {
    padding-right: 10px;
    cursor: pointer;
  }

  .languages p.active {
    color: var(--accent);
  }
</style>
